import { render, staticRenderFns } from "./crmpay.vue?vue&type=template&id=54c2afc4&scoped=true&"
import script from "./crmpay.vue?vue&type=script&lang=js&"
export * from "./crmpay.vue?vue&type=script&lang=js&"
import style0 from "./crmpay.vue?vue&type=style&index=0&id=54c2afc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c2afc4",
  null
  
)

export default component.exports